import "./App.css";
import "./admin/admin.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import { Toaster } from "./components/ui/sonner";
import { AdminAuthProvider } from "./contexts/AdminAuthContext";
import AdminLogin from "./admin/Login";
import AdminLayout from "./admin/AdminLayout";
import Dashboard from "./admin/Dashboard";
import Leads from "./admin/Leads";
import SaleReport from "./admin/SaleReport";
import Reports from "./admin/Reports";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AdminAuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />

            {/* Hidden admin area — not linked from anywhere, noindex */}
            <Route path="/o2-control-panel" element={<AdminLogin />} />
            <Route path="/o2-control-panel/dashboard" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
            </Route>
            <Route path="/o2-control-panel/leads" element={<AdminLayout />}>
              <Route index element={<Leads />} />
            </Route>
            <Route path="/o2-control-panel/sales" element={<AdminLayout />}>
              <Route index element={<SaleReport />} />
            </Route>
            <Route path="/o2-control-panel/reports" element={<AdminLayout />}>
              <Route index element={<Reports />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AdminAuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
